import { get, writable } from 'svelte/store';
import { fetchApiKit } from 'Services/fetchApiKit';
import { goto } from '$app/navigation';
import { page } from '$app/stores';

export const RedirectToStep = {
	0: '/v2/reservation-de-groupe',
	1: '/v2/reservation-de-groupe/date',
	2: '/v2/reservation-de-groupe/hours',
	3: '/v2/reservation-de-groupe/party-size',
	4: '/v2/reservation-de-groupe/more-info',
	5: '/v2/reservation-de-groupe/confirm'
};

export const steps = { date: 1, hour: 2, party_size: 3, more_info: 4, confirmation: 5 };

export const flyParams = {
	in: { x: 20, duration: 250, delay: 250 },
	out: { x: 20, duration: 250 }
};

export const bq = writable({
	date: null,
	time: null,
	nbPersons: 0,
	nbChildren: 0,
	budget: null,
	idEvent: 1,
	message: '',
	isFrom: 1
});

export const restaurant = writable({
	token: '',
	name: '',
	nbMinForGroup: 0,
	nbMaxForGroup: 0
});

export const theme = writable({});

export const customer = writable({});

export const groupLink = writable('');

const back = () => goto(RedirectToStep[get(page).data.step - 1] + get(page).data.search);

const next = () => goto(RedirectToStep[get(page).data.step + 1] + get(page).data.search);

export const pageState = writable({
	isPro: false,
	shouldRedirect: true,
	sm: false,
	smd: false,
	md: false,
	xs: false,
	error: null,
	isError: false,
	back: back,
	next: next,
	triggerStepAction: () => {}
});

export const GbmMethods = {
	get: (restaurantToken) => {
		return fetchApiKit(
			{
				route: `/restaurant/public/${restaurantToken}`,
				method: 'GET',
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
			},
			{
				retry: false
			}
		);
	},
	create: (token, body) => {
		return fetchApiKit(
			{
				route: `/bookquotation/create/${token}`,
				method: 'POST',
				body: JSON.stringify(body),
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
			},
			{
				retry: false
			}
		);
	},
	update: (id, body) => {
		return fetchApiKit(
			{
				route: `/customer/public/${id}`,
				method: 'PATCH',
				body: JSON.stringify(body),
				headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
			},
			{
				retry: false
			}
		);
	}
};
